import React from 'react';
import { FILE_UPLOAD_STATES } from '../../constants';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import { LinearProgress } from '@material-ui/core';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { formatBytes } from 'react-dropzone-uploader';
import { getImageURLBasedOnMimeType } from '../../utils';
import { getFormattedString } from '../../../../utils';
import useStyles from './styles';
import RemoveButton from '../../components/removeButton/RemoveButton';
import ErrorIcon from '../../../../assets/error-icon.png';
import Button from '@material-ui/core/Button';

const BoxedPreview = props => {
  const {
    meta,
    fileWithMeta: { restart },
  } = props;
  const { name, percent, status, previewUrl, type, size } = meta;
  const classes = useStyles();

  const isDone = status === FILE_UPLOAD_STATES.DONE;
  const isError = status === FILE_UPLOAD_STATES.FAILED;
  const imageURL = isError ? ErrorIcon : getImageURLBasedOnMimeType(type, previewUrl);
  const formattedName = getFormattedString(name, 25);

  const handleRemove = () => {
    const { fileWithMeta } = props;
    fileWithMeta.remove();
  };

  const handleRestart = () => restart();

  return (
    <Card className={classes.root}>
      <CardActionArea>
        {imageURL ? <CardMedia className={classes.media} image={imageURL} title={name} /> : null}
        <CardContent className={classes.contentRoot}>
          <Typography align="center" className={classes.uploadTitle}>{`${formattedName} | ${formatBytes(
            size,
          )}`}</Typography>
        </CardContent>
      </CardActionArea>
      <CardActions className={classes.actions}>
        <RemoveButton onRemoveHandler={handleRemove} />
        {isError ? (
          <Button color="primary" onClick={handleRestart} variant="contained">
            Retry
          </Button>
        ) : null}
      </CardActions>
      {!isDone ? <LinearProgress value={percent} variant="determinate" /> : null}
    </Card>
  );
};

export default BoxedPreview;
